const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMan9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 400,
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M-973.9 230.335c101.51 10.776 95.086-15.763 180.061-18.577 18.885-2.746 17.635-17.46-.449-16.017-90.368 2.243-58.78 34.94-177.693 16.091-28.997-5.176-24.264 14.568-1.919 18.503",
    style: {
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(1034.343 -3.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-882.636 187.136c1.312-3.924-7.997-10.181-13.22-3.472-4.83 7.479-6.263 12.155-10.86 17.42-1.958 2.393-2.24 7.725-.216 9.267 7.568 6.199 6.724 4.784 11.5 14.738l20.53-1.762c-6.52-8.589-7.597-7.834-10.131-16.424-1.165-9.327-.808-10.176 2.397-19.767M-856.843 149.174c-2.072-2.165-3.31-2.932-6.213 0l-15.391 15.54c-1.348 1.501-1.372 3.706-.264 4.97l9.17 8.834c4.353 4.252 5.464 7.314 2.9 12.336-3.42 9.616-5.987 19.367-6.097 24.708l21.18-3.487c-3.959-9.818-3.87-12.358 2.866-21.647 5.559-6.327 10.933-7.774 5.995-16.417zM-834.44 229.53c-2.379 0-5.115.351-7.986.675-25.98 4.24-44.632 13.662-87.783 12.14-5.841.03-10.797 3.109-10.592 7.59.416 9.893 7.7 62.177 8.305 66.89.853 6.417 9.79 6.987 10.967 1.34.215-1.033.221-3.957.098-7.995.547-1.144 1.397-2.02 2.308-2.184l56.983-5.092c.58.007 1.014.545 1.32 1.33-.442 20.094-.684 39.742-.254 46.624.124 1.52.051 3.12 1.57 4.486 3.627 3.034 24.108 1.363 29.408-1.947 1.469-1.078 2-1.583 2.198-3.83-2.961-33.992-.668-77.218 1.605-110.873.597-7.453-2.911-9.155-8.146-9.155m-26.98 16.763c5.652-1.39 2.022 15.828.088 15.877l-58.828 4.611c-5.127-1.024-4.88-13.066-1.422-13.228 26.639-.896 35.744-3.181 60.162-7.26m-.129 29.152c1.706-.13 2.018 12.385-.38 12.586l-57.32 4.797c-4.102-1.15-4.353-11.962-.78-12.492z",
    style: {
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(1034.343 -3.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-881.542 246.32-19.233.635-5.291 90.56c-.751 10.291 4.492 20.61 11.24 20.762l18.743-6.546z",
    style: {
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(1034.343 -3.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-942.636 354.94.846 8.028c54.246 18.284 41.637-8.576 96.894-15.151l-.634-4.928c-42.242-2.988-64.353 13.179-97.106 12.051",
    style: {
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(1034.343 -3.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-947.816 295.507c-4.79-14.35-18.047-11.53-15.57.885 13.898 43.448 17.943 67.498 19.8 70.859 10.792 18.228 18.402 13.453 19.078-2.434.112-4.85-14.234-43.495-23.308-69.31",
    style: {
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(1034.343 -3.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-990.503 324.512c-8.36-1.304-7.6 9.084-3.317 11.288 59.848 26.468 123.839-8.865 177.967-5.69 2.058.368 5.312 1.563 8.294 3.201 9.557 5.048 3.734 19.51-.976 22.479-21.536 9.845-16.514.091-40.673 11.25-2.278 1.46-8.257 2.596-10.482 1.685-8.943-2.978-16.302-8.103-22.15-12.665l-11.189 5.646c6.906 8.601 17.1 12.672 25.541 16.372 6.747 3.213 14.126 2.854 19.03 3.005 25.107.345 48.588-9.297 60.402-10.755 3.458-.53 7.483-6.526 9.05-9.31 9.692-15.872 5.689-18.57-1.085-35.189-3.85-6.232-14.98-8.011-20.828-8.804-60.717-2.575-138.254 18.811-189.584 7.487",
    style: {
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(1034.343 -3.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.548 677.437c.545-9.273-36.812-17.959-33.246-4.272 17.95 62.02-5.542 79.39-66.766 100.842-4.171 1.146-5.269 9.321 1.845 7.116 64.538-20.004 103.843-24.603 98.167-103.686",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-.322 -652.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.576 718.65c-5.844-2.2-10.977-5.451-14.363-10.567-.6-.9-2.23-8.686 1.975-9.148 16.174-1.78 7.18-6.608 10.673-7.333 21.63-4.487 52.321-17.632 71.642-22.718 10.802-2.844 17.882-11.073 21.272-10.055 12.271-.89 13.764 25.67 5.868 27.626-31.095 4.564-48.763 2.638-79.859 11.443z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-.322 -652.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.441 679.723c.56-10.217-8.388-6.918-11.027 3.186 3.165 28.798-18.621 73.622 5.9 102.02 11.286 13.07 72.51 13.303 84.392 4.714 17.017-14.572 7.853-28.294-2.366-27.88-19.384 1.45-19.42-50.074-27.58-48.9-8.694 1.635.641 48.839-6.381 54.135-11.28 8.357-30.812-3.746-36.187-11.111-14.781-20.253-3.422-56.25-6.75-76.164",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-.322 -652.362)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan9);
export default __webpack_public_path__ + "static/media/Man9.1cf649e6e614e2228304ea02755f8296.svg";
export { ForwardRef as ReactComponent };